export enum LanguageCodeEnum {
    CZ = "CZ",
    SK = "SK"
}